import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    token: null,
    userInfo: {
      id: '',
      nickname: '',
      messageNum: 0,
      chartNum: 0,
      avatar: '',//头像
      isServicer: null,
    },
    otherid: '',
    chatFlag: false,
    screenHeight: window.innerHeight
  },
  mutations: {
    setOtherid(state, newID) {
      alert(newID);
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js